// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form can be used to <strong>replace</strong> existing Instapay members in the system. File should be in
    <strong>Excel (xlsx, xls)</strong> with correct header and data.
  </span>
</div>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Upload Instapay Members</td>
      <td>
        <file-upload
          ng-model="\$ctrl.membersFile"
          ng-required="true"
          validate='{pattern: ".xls,*.xlsx"}'
          max-files="1"
          show-file-name="true"
          show-remarks="false"
          enable-webcam="false">
      </file-upload>
      </td>
      <td>
        <button
          type="button"
          class="btn btn-primary"
          ng-click="\$ctrl.downloadSampleFile()">
      Download sample
    </button>
      </td>
    </tr>
    </tbody>
  </table>
</form>
<div class="flex-end">
  <button 
    type="button" 
    class=" btn btn-primary" 
    ng-disabled="!\$ctrl.membersFile"
    ng-click="\$ctrl.execute()">
    Execute  
  </button>
</div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/upload-instapay-members/upload-instapay-members.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;